import axios from "axios";

type THistory = {
  navigate: (path: string) => void;
};
export const createInterceptors = ({ navigate }: THistory) => {
  axios.interceptors.request.use(
    async config => {
      const token = window.localStorage.getItem("token-crombie-docs");
      if (token) {
        config.headers = {
          Authorization: `Bearer ${token}`
        };
      }
      return config;
    },
    error => Promise.reject(error)
  );

  axios.interceptors.response.use(
    async response => {
      return response;
    },
    error => {
      if (error.__CANCEL__) {
        // eslint-disable-next-line no-console
        return;
      }

      if (error.response && error.response.status === 401) {
        if (window.localStorage.getItem("token-crombie-docs") !== null) {
          window.localStorage.removeItem("token-crombie-docs");
        }
        navigate("/logout");
      }
      // eslint-disable-next-line no-console
      console.error(error);

      return Promise.reject(error);
    }
  );
};
export const useAuthContex = () => {
  return { createInterceptors };
};
